import * as React from 'react';

const iframe = '<iframe src="https://datastudio.google.com/embed/u/0/reporting/1qfgdlzBydJZ7v1hFMNI1HJtAIundCC1r/page/g0i2" scrolling="no" frameborder="0" allowfullscreen style="width:100%; height: 100%; border: none; overflow: hidden"></iframe>';

interface Props {
    iframe: string;
}

export class MyFrame extends React.Component<Props, {}> {
    iframe() {
        return {
            __html: this.props.iframe
        };
    }

    render() {
        return (
            // <div style={{ height: '100vh', overflow: 'hidden', position:'absolute'}}>
                <div style={{ height: '100%', overflow: 'hidden' }} dangerouslySetInnerHTML={this.iframe()} />
            // </div>
        );
    }
}

export default class Dashboard extends React.Component {
    render() {
        return (
            <MyFrame iframe={iframe} />
        );
    }

}


// WEBPACK FOOTER //
// ./src/dashboards/containers/merchantStatus.tsx